import { CiCirclePlus, CiSquareMinus, CiSquarePlus } from "react-icons/ci";
import React, { useEffect, useState } from "react";
import { PortfolioAssets } from "./PortfolioAssets";
import { SchemeTypeWise } from "./SchemeTypeWise";
import {
  calculateTotalFloat,
  formatRupees,
} from "../../../utils/inputsValidation";
import moment from "moment/moment";
import { FaEye } from "react-icons/fa";
import api from "../../../utils/api";
import { useLocation } from "react-router-dom";
import socket from "../../../context/socket";

const PortfolioDetails = ({
  isStatesData,
  users,
  isEquityDiv,
  isSIFDiv,
  isHybridDiv,
  isDebtDiv,
  isOtherDiv,
  isLoading,
  portfolioAsset,
  schemeType,
  statesData,
  isDarkMode,
  indexedPortfolio,
}) => {
  console.log(
    "hybridDiv",
    users,
    isHybridDiv,
    isEquityDiv,
    isDebtDiv,
    statesData
  );

  const [showEquity, setShowEquity] = useState(false);
  const [showSIF, setShowSIF] = useState(false);
  const [showHybrid, setShowHybrid] = useState(false);
  const [showDebt, setShowDebt] = useState(false);
  const [showOthers, setShowOthers] = useState(false);

  const [openItems, setOpenItems] = useState({});

  const [expandedRowKey, setExpandedRowKey] = useState(null);
  const [folioData, setFolioData] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingRowKey, setLoadingRowKey] = useState(null);


  const [expandedEquityRow, setExpandedEquityRow] = useState(null);
  const [expandedHybridRow, setExpandedHybridRow] = useState(null);
  const [expandedDebtRow, setExpandedDebtRow] = useState(null);

  const [expandedSchemes, setExpandedSchemes] = useState({});
  const [expandedTransactions, setExpandedTransactions] = useState({});
  const roomId = new URLSearchParams(useLocation().search).get("clientId");
  

  const handleToggleEquityRow = (index) => {
    setExpandedEquityRow((prev) => (prev === index ? null : index));
  };
  const handleToggleHybridRow = (index) => {
    setExpandedHybridRow((prev) => (prev === index ? null : index));
  };
  const handleToggleDebtRow = (index) => {
    setExpandedDebtRow((prev) => (prev === index ? null : index));
  };

  const emitSocket = (showEquity,showSIF, showDebt, showHybrid, showOthers, roomId,item=false) => {
    socket.emit("my-investment-toggle", {
      room: roomId, data: {
        showEquity: showEquity,
        showSIF: showSIF,
        showDebt: showDebt,
        showHybrid: showHybrid,
        showOthers: showOthers,
        item: item
      }
    });
}
  useEffect(() => {
console.log("Emitting my-investment-toggle" )
    emitSocket(showEquity, showSIF, showDebt, showHybrid, showOthers, roomId)
  }, [showEquity, showSIF, showDebt,showHybrid,showOthers,roomId]);


  const toggleScheme = (schemeId) => {
    console.log(schemeId,"schemeId")
    setExpandedSchemes((prev) => ({
      ...prev,
      [schemeId]: !prev[schemeId],
    }));
  };

  const toggleTransactions = (schemeId) => {
    setExpandedTransactions((prev) => ({
      ...prev,
      [schemeId]: !prev[schemeId],
    }));
  };

  // Function to toggle a specific scheme
  const toggleItem = (index) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the specific index
    }));
  };


  // const handleToggleExpand = (index) => {
  //   setExpandedRow(expandedRow === index ? null : index);
  // };

  const toggleEquity = () => {
    if (isEquityDiv) {
      setShowEquity(!showEquity);
    }
  };
  const toggleSIF = () => {
    if (isSIFDiv) {
      setShowSIF(!showSIF);
    }
  };

  const toggleHybrid = () => {
    if (isHybridDiv) {
      setShowHybrid(!showHybrid);
    }
  };

  const toggleDebt = () => {
    if (isDebtDiv) {
      setShowDebt(!showDebt);
    }
  };

  const renderInfoRow = (label, value) => (
    <div className="d-flex justify-content-between my-4">
      <span className="">{label}</span>
      <span className="fs-16">{value || "N/A"}</span>
    </div>
  );

  console.log("isStatesData", isStatesData, portfolioAsset);

  const isSIFportfolioData = Object.values(
    indexedPortfolio?.SIF || {}
  ).flat();
  const isEquityportfolioData = Object.values(
    indexedPortfolio?.Equity || {}
  ).flat();
  const isHybridportfolioData = Object.values(
    indexedPortfolio?.Hybrid || {}
  ).flat();
  const isDebtportfolioData = Object.values(indexedPortfolio?.Debt || {}).flat();
  const isOthers = Object.values(indexedPortfolio?.Others||indexedPortfolio?.Other  || {}).flat();
  console.log('isOthers', isOthers, isDebtportfolioData);


  // ✅ Totals
  const totalInvestment = [
    ...isEquityportfolioData,
    ...isHybridportfolioData,
    ...isDebtportfolioData,
    ...isOthers
  ].reduce(
    (acc, item) => {
      acc.invested += item?.inv_cost || 0;
      acc.current += item.cur_value || 0;
      acc.gain += item?.gain_loss || 0;
      return acc;
    },
    { invested: 0, current: 0, gain: 0 }
  );

  const parsePercentage = (val) => {
    if (!val) return 0;
    return Number(val.replace("%", "").trim()) || 0;
  };




  // ✅ Improved version with async/await, error handling, and feedback
  const handleOpenTrans = async (item) => {
    emitSocket(showEquity, showSIF, showDebt, showHybrid, showOthers, roomId,item)
    const key = `${item.fund_id}_${item.folio_id}`;

    // Toggle collapse
    if (expandedRowKey === key) {
      setExpandedRowKey(null);
      return;
    }

    // If already cached, just open it
    if (folioData[key]) {
      setExpandedRowKey(key);
      return;
    }

    // ✅ Step 1: Immediately open the row & show loader
    setExpandedRowKey(key);
    setLoadingRowKey(key);

    try {
      const payload = {
        FolioID: item.folio_id,
        FundId: item.fund_id,
      };

      console.log("Fetching transactions for:", payload);

      const response = await api.post("advisor/getTransectionWM", payload);
      const data = response?.data || {};

      const transactions = Array.isArray(data.transactions)
        ? data.transactions
        : [];
      const transactionTotal = data.transactionTotal || null;

      // ✅ Step 2: Cache data
      setFolioData((prev) => ({
        ...prev,
        [key]: { transactions, transactionTotal },
      }));
    } catch (error) {
      console.error("❌ Error fetching transaction data:", error);
    } finally {
      // ✅ Step 3: Stop loading once data fetched
      setLoadingRowKey(null);
    }
  };




  return (
    <div className="container">
      <div className="row gap-3 ">
        {Object.keys(isStatesData).length > 0 ? (
          <div
            className="tab-pane fade show active"
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabindex="0"
          >
            <div className="row d-flex justify-content-around justify-content-md-between gap-2">
              {/* Invested amount */}
              <div className="col-12 col-sm-6 col-md-4 col-lg-2 text-center py-2 bg-white brdr border border-1 d-flex flex-column justify-content-center align-items-center px-1">
                <p className="my-1 md:mb-3">Invested amount</p>
                <p className="fs-21 fw-medium">
                  {formatRupees(isStatesData["Invested Amount"])}
                </p>
              </div>

              {/* Current Value */}
              <div className="col-12 col-sm-6 col-md-4 col-lg-2 text-center py-2 bg-white brdr border border-1 d-flex flex-column justify-content-center align-items-center px-1">
                <p className="my-1 md:mb-3">Current Value</p>
                <p className="fs-21 fw-medium">
                  {formatRupees(isStatesData["Current Value"])}
                </p>
              </div>

              {/* Total Gain / Loss */}
              <div className="col-12 col-sm-6 col-md-4 col-lg-2 text-center py-2 bg-white brdr border border-1 d-flex flex-column justify-content-center align-items-center px-1">
                <p className="my-1 md:mb-3">Total Gain / Loss</p>
                <p className="fs-21 fw-medium">
                  {formatRupees(isStatesData["Total Gain / Loss"])}
                </p>
              </div>

              {/* XIRR */}
              <div className="col-12 col-sm-6 col-md-4 col-lg-2 text-center py-2 bg-white brdr border border-1 d-flex flex-column justify-content-center align-items-center px-1">
                <p className="my-1 md:mb-3">XIRR</p>
                <p className="fs-21 fw-medium">
                  {isStatesData["Annualized Return(CAGR)"]}%
                </p>
              </div>

              {/* Absolute Return */}
              <div className="col-12 col-sm-6 col-md-4 col-lg-2 text-center py-2 bg-white brdr border border-1 d-flex flex-column justify-content-center align-items-center px-1">
                <p className="my-1 md:mb-3">Absolute Return</p>
                <p className="fs-21 fw-medium">
                  {isStatesData["Absolute Return"]}%
                </p>
              </div>
            </div>

            <style>
              {`
      @media (min-width: 768px) {
        .col-md {
          width: 244px !important;
          height: 87px !important;
        }
      }
    `}
            </style>

            <div className="row mt-5 g-4">
              <div className="col-12 col-md-6">
                <div className="border border-1 white brdr p-3 h-100">
                  <p className="fs-21 mb-2 text-center text-md-start">
                    Portfolio assets allocation
                  </p>
                  <div className="d-flex justify-content-center">
                    <PortfolioAssets
                      portfolioAsset={portfolioAsset}
                      isDarkMode={isDarkMode}
                    />
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="border border-1 white brdr p-3 h-100">
                  <p className="fs-21 mb-2 text-center text-md-start">
                    Scheme Type Wise Allocation
                  </p>
                  <div className="d-flex justify-content-center">
                    <SchemeTypeWise
                      schemeType={schemeType}
                      isDarkMode={isDarkMode}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Desktop Table start */}

            <div className="d-none d-md-block">
              <div className="table-responsive">
                <table
                  className="table mb-0 text-center"
                  style={{ borderColor: "#52B58C" }}
                >
                  <thead className="thead-light">
                    <tr>
                      <th></th>
                      <th className="txt-color text-start">Particular</th>
                      <th className="txt-color">Investment</th>
                      <th className="txt-color">Latest Value</th>
                      <th className="txt-color">Total Gain/Loss</th>
                      <th className="txt-color">XIRR</th>
                      <th className="txt-color">Absolute Return</th>
                    </tr>
                  </thead>

                  <tbody>
                    {/* ===== EQUITY HEADER ===== */}
                    {isEquityportfolioData?.length > 0 && (
                      <>
                        <tr>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            {showEquity ? (
                              <CiSquareMinus
                                className="fs-3 clrgreen"
                                onClick={() => setShowEquity(!showEquity)}
                                style={{ cursor: "pointer" }}
                              />
                            ) : (
                              <CiSquarePlus
                                className="fs-3 clrgreen"
                                onClick={() => setShowEquity(!showEquity)}
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen fw-bold text-start">
                              Equity
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isEquityDiv?.investment || 0)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isEquityDiv?.latest_value || 0)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isEquityDiv?.total_gain_loss || 0)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {/* {(
                                  parsePercentage(isEquityDiv?.cagr) || 0
                                ).toFixed(2)}
                                % */}
                              -
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {(
                                parsePercentage(isEquityDiv?.absolute_return) ||
                                0
                              ).toFixed(2)}
                              %
                            </p>
                          </td>
                        </tr>

                        {/* ===== SUB-CATEGORY & SCHEMES ===== */}
                        {showEquity &&
                          Object.entries(
                            isEquityportfolioData.reduce((acc, item) => {
                              if (!acc[item.Sub_Category])
                                acc[item.Sub_Category] = [];
                              acc[item.Sub_Category].push(item);
                              return acc;
                            }, {})
                          ).map(([subCategory, items], groupIndex) => (
                            <React.Fragment key={`equity-group-${groupIndex}`}>
                              {/* Sub-category header */}
                              <tr>
                                <th
                                  scope="col"
                                  colSpan="14"
                                  style={{ backgroundColor: "#d0ebd0", color: "#23674b" }}
                                  className="fs-12 text-start m-0 py-3 fw-semibold"
                                >
                                  {subCategory}
                                </th>
                              </tr>
                              {/* Inner schemes table */}
                              <tr className="m-0">
                                <td
                                  colSpan="7"
                                  className="p-0"
                                  style={{ backgroundColor: "#eaf5f1" }}
                                >
                                  <div className="row m-0  pb-1">
                                    <table className="table mb-0">
                                      <thead>
                                        <tr>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Scheme name
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Inv Since
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Inv Cost
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Units
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Pur NAV
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Cur NAV
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              NAV date
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              Cur Value
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Gain/Loss
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              XIRR
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Abs return
                                            </span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {/* Schemes under this sub-category */}
                                        {items.map((item, index) => {
                                          const rowKey = `${item.fund_id}_${item.folio_id}`;
                                          const isOpen = expandedRowKey === rowKey;
                                          const currentData = folioData[rowKey];


                                          return (
                                            <React.Fragment key={rowKey}>
                                              {/* Main scheme row */}
                                              <tr>
                                                <td className="text-start">
                                                  <p className="fs-12 m-0">{item.scheme_name}</p>
                                                  <span className="fs-12 fw-bold m-0">{item.folio}</span>
                                                  <span>
                                                    <span
                                                      className="clrgreen ms-2"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => handleOpenTrans(item)}
                                                    >
                                                      {isOpen ? <CiSquareMinus /> : <CiSquarePlus />}
                                                    </span>
                                                  </span>
                                                </td>
                                                <td className="fs-12">{item.InvestedSince}</td>
                                                <td className="fs-12">{formatRupees(item?.inv_cost)}</td>
                                                <td className="fs-12">{Number(item?.UnitsHeld).toFixed(2)}</td>
                                                <td className="fs-12">{Number(item.pur_nav).toFixed(2)}</td>
                                                <td className="fs-12">{Number(item.CurrentNAV).toFixed(2)}</td>
                                                <td className="fs-12">{moment(item.nav_date).format("DD/MM/YYYY")}</td>
                                                <td className="fs-12">{formatRupees(item.cur_value)}</td>
                                                <td className="fs-12">{formatRupees(item?.gain_loss)}</td>
                                                <td className="fs-12">{item.cagr}%</td>
                                                <td className="fs-12">{item.abs_return}%</td>
                                              </tr>

                                              {/* Transactions table */}
                                              {isOpen && (
                                                <tr>
                                                  <td colSpan="14" className="p-1 bg-grey">
                                                    {loadingRowKey === rowKey ? (
                                                      <div className="text-center py-3">Loading transactions...</div>
                                                    ) : (
                                                      <table className="table table-sm mb-0">
                                                        <thead className="thead-light">
                                                          <tr>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Txn Type
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Date
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Amount
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Price
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Units
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Cur NAV
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                NAV date
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Value
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Gain/Loss
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Days
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Abs Return
                                                              </span>
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {currentData?.transactions?.length > 0 ? (
                                                            currentData.transactions.map((txn, tIndex) => (
                                                              <tr key={tIndex}>
                                                                <td className="fs-12">
                                                                  {txn.Description
                                                                    ? txn.Description
                                                                      .replace(/In Installment No/gi, "")
                                                                      .replace(/Installment No/gi, "")
                                                                      .replace(/SIP Installment\s*\d+\/\d+/gi, "SIP Purchase")
                                                                      .replace(/^SIP$/, "SIP Purchase")
                                                                      .trim()
                                                                    : ""}
                                                                </td>
                                                                <td className="fs-12">{txn.TransactionDate || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? Number(txn.CreditAmount || 0).toFixed(2)
                                                                    : Number(txn.DebitAmount || 0).toFixed(2)}
                                                                </td>
                                                                <td className="fs-12">{txn.TradePrice || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? Number(txn.CreditUnits || 0).toFixed(2)
                                                                    : Number(txn.DebitUnits || 0).toFixed(2)}
                                                                </td>
                                                                <td className="fs-12">{txn.curr_nav || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.nav_date
                                                                    ? moment(txn.nav_date).format("DD/MM/YYYY")
                                                                    : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward ? formatRupees(txn.curr_val) : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward ? formatRupees(txn?.gain_loss) : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? txn._days
                                                                    : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? `${(parseFloat(txn.abs_return) * 100).toFixed(2)} %`
                                                                    : "--"}
                                                                </td>
                                                              </tr>
                                                            ))
                                                          ) : (
                                                            <tr>
                                                              <td colSpan="11" className="text-center py-2">
                                                                No transactions found
                                                              </td>
                                                            </tr>
                                                          )}

                                                          {/* ✅ Total Row */}
                                                          {currentData?.transactionTotal && (
                                                            <tr>
                                                              <th
                                                                colSpan={2}
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  Total
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {formatRupees(item?.inv_cost) || "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {item
                                                                    .transactionTotal
                                                                    ?.AvgCost ||
                                                                    "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {Number(item?.UnitsHeld).toFixed(2)}
                                                                  {/* {Number(
                                                                    item
                                                                      .transactionTotal
                                                                      ?.UnitsHeld
                                                                  ).toFixed(2) ||
                                                                    "-"} */}
                                                                </span>
                                                              </th>
                                                              <th
                                                                colSpan={3}
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              />
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {formatRupees(item?.gain_loss) || "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">

                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {item?.abs_return ||
                                                                    "-"}
                                                                  %
                                                                </span>
                                                              </th>
                                                            </tr>
                                                          )}

                                                        </tbody>
                                                      </table>
                                                    )}
                                                  </td>
                                                </tr>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}

                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                      </>
                    )}
                    {/* ===== EQUITY HEADER ===== */}
                    {isSIFportfolioData?.length > 0 && (
                      <>
                        <tr>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            {showSIF ? (
                              <CiSquareMinus
                                className="fs-3 clrgreen"
                                onClick={() => setShowSIF(!showSIF)}
                                style={{ cursor: "pointer" }}
                              />
                            ) : (
                              <CiSquarePlus
                                className="fs-3 clrgreen"
                                onClick={() => setShowSIF(!showSIF)}
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen fw-bold text-start">
                              SIF
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isSIFDiv?.investment || 0)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isSIFDiv?.latest_value || 0)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isSIFDiv?.total_gain_loss || 0)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {/* {(
                                  parsePercentage(isSIFDiv?.cagr) || 0
                                ).toFixed(2)}
                                % */}
                              -
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {(
                                parsePercentage(isSIFDiv?.absolute_return) ||
                                0
                              ).toFixed(2)}
                              %
                            </p>
                          </td>
                        </tr>

                        {/* ===== SUB-CATEGORY & SCHEMES ===== */}
                        {showSIF &&
                          Object.entries(
                            isSIFportfolioData.reduce((acc, item) => {
                              if (!acc[item.Sub_Category])
                                acc[item.Sub_Category] = [];
                              acc[item.Sub_Category].push(item);
                              return acc;
                            }, {})
                          ).map(([subCategory, items], groupIndex) => (
                            <React.Fragment key={`equity-group-${groupIndex}`}>
                              {/* Sub-category header */}
                              <tr>
                                <th
                                  scope="col"
                                  colSpan="14"
                                  style={{ backgroundColor: "#d0ebd0", color: "#23674b" }}
                                  className="fs-12 text-start m-0 py-3 fw-semibold"
                                >
                                  {subCategory}
                                </th>
                              </tr>
                              {/* Inner schemes table */}
                              <tr className="m-0">
                                <td
                                  colSpan="7"
                                  className="p-0"
                                  style={{ backgroundColor: "#eaf5f1" }}
                                >
                                  <div className="row m-0  pb-1">
                                    <table className="table mb-0">
                                      <thead>
                                        <tr>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Scheme name
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Inv Since
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Inv Cost
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Units
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Pur NAV
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Cur NAV
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              NAV date
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              Cur Value
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Gain/Loss
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              XIRR
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Abs return
                                            </span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {/* Schemes under this sub-category */}
                                        {items.map((item, index) => {
                                          const rowKey = `${item.fund_id}_${item.folio_id}`;
                                          const isOpen = expandedRowKey === rowKey;
                                          const currentData = folioData[rowKey];


                                          return (
                                            <React.Fragment key={rowKey}>
                                              {/* Main scheme row */}
                                              <tr>
                                                <td className="text-start">
                                                  <p className="fs-12 m-0">{item.scheme_name}</p>
                                                  <span className="fs-12 fw-bold m-0">{item.folio}</span>
                                                  <span>
                                                    <span
                                                      className="clrgreen ms-2"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => handleOpenTrans(item)}
                                                    >
                                                      {isOpen ? <CiSquareMinus /> : <CiSquarePlus />}
                                                    </span>
                                                  </span>
                                                </td>
                                                <td className="fs-12">{item.InvestedSince}</td>
                                                <td className="fs-12">{formatRupees(item?.inv_cost)}</td>
                                                <td className="fs-12">{Number(item?.UnitsHeld).toFixed(2)}</td>
                                                <td className="fs-12">{Number(item.pur_nav).toFixed(2)}</td>
                                                <td className="fs-12">{Number(item.CurrentNAV).toFixed(2)}</td>
                                                <td className="fs-12">{moment(item.nav_date).format("DD/MM/YYYY")}</td>
                                                <td className="fs-12">{formatRupees(item.cur_value)}</td>
                                                <td className="fs-12">{formatRupees(item?.gain_loss)}</td>
                                                <td className="fs-12">{item.cagr}%</td>
                                                <td className="fs-12">{item.abs_return}%</td>
                                              </tr>

                                              {/* Transactions table */}
                                              {isOpen && (
                                                <tr>
                                                  <td colSpan="14" className="p-1 bg-grey">
                                                    {loadingRowKey === rowKey ? (
                                                      <div className="text-center py-3">Loading transactions...</div>
                                                    ) : (
                                                      <table className="table table-sm mb-0">
                                                        <thead className="thead-light">
                                                          <tr>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Txn Type
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Date
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Amount
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Price
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Units
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Cur NAV
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                NAV date
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Value
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Gain/Loss
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Days
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Abs Return
                                                              </span>
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {currentData?.transactions?.length > 0 ? (
                                                            currentData.transactions.map((txn, tIndex) => (
                                                              <tr key={tIndex}>
                                                                <td className="fs-12">
                                                                  {txn.Description
                                                                    ? txn.Description
                                                                      .replace(/In Installment No/gi, "")
                                                                      .replace(/Installment No/gi, "")
                                                                      .replace(/SIP Installment\s*\d+\/\d+/gi, "SIP Purchase")
                                                                      .replace(/^SIP$/, "SIP Purchase")
                                                                      .trim()
                                                                    : ""}
                                                                </td>
                                                                <td className="fs-12">{txn.TransactionDate || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? Number(txn.CreditAmount || 0).toFixed(2)
                                                                    : Number(txn.DebitAmount || 0).toFixed(2)}
                                                                </td>
                                                                <td className="fs-12">{txn.TradePrice || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? Number(txn.CreditUnits || 0).toFixed(2)
                                                                    : Number(txn.DebitUnits || 0).toFixed(2)}
                                                                </td>
                                                                <td className="fs-12">{txn.curr_nav || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.nav_date
                                                                    ? moment(txn.nav_date).format("DD/MM/YYYY")
                                                                    : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward ? formatRupees(txn.curr_val) : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward ? formatRupees(txn?.gain_loss) : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? txn._days
                                                                    : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? `${(parseFloat(txn.abs_return) * 100).toFixed(2)} %`
                                                                    : "--"}
                                                                </td>
                                                              </tr>
                                                            ))
                                                          ) : (
                                                            <tr>
                                                              <td colSpan="11" className="text-center py-2">
                                                                No transactions found
                                                              </td>
                                                            </tr>
                                                          )}

                                                          {/* ✅ Total Row */}
                                                          {currentData?.transactionTotal && (
                                                            <tr>
                                                              <th
                                                                colSpan={2}
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  Total
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {formatRupees(item?.inv_cost) || "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {item
                                                                    .transactionTotal
                                                                    ?.AvgCost ||
                                                                    "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {Number(item?.UnitsHeld).toFixed(2)}
                                                                  {/* {Number(
                                                                    item
                                                                      .transactionTotal
                                                                      ?.UnitsHeld
                                                                  ).toFixed(2) ||
                                                                    "-"} */}
                                                                </span>
                                                              </th>
                                                              <th
                                                                colSpan={3}
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              />
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {formatRupees(item?.gain_loss) || "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">

                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {item?.abs_return ||
                                                                    "-"}
                                                                  %
                                                                </span>
                                                              </th>
                                                            </tr>
                                                          )}

                                                        </tbody>
                                                      </table>
                                                    )}
                                                  </td>
                                                </tr>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}

                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                      </>
                    )}
                    {/* ===== HYBRID HEADER ===== */}
                    {isHybridportfolioData?.length > 0 && (
                      <>
                        <tr>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            {showHybrid ? (
                              <CiSquareMinus
                                className="fs-3 clrgreen"
                                onClick={() => setShowHybrid(!showHybrid)}
                                style={{ cursor: "pointer" }}
                              />
                            ) : (
                              <CiSquarePlus
                                className="fs-3 clrgreen"
                                onClick={() => setShowHybrid(!showHybrid)}
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen fw-bold text-start">
                              Hybrid
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isHybridDiv?.investment || 0)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isHybridDiv?.latest_value)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isHybridDiv?.total_gain_loss)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {/* {(
                                  parsePercentage(isHybridDiv?.cagr) || 0
                                ).toFixed(2)}
                                % */}
                              -
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {(
                                parsePercentage(isHybridDiv?.absolute_return) ||
                                0
                              ).toFixed(2)}
                              %
                            </p>
                          </td>
                        </tr>

                        {/* ===== SUB-CATEGORY & SCHEMES ===== */}
                        {showHybrid &&
                          Object.entries(
                            isHybridportfolioData.reduce((acc, item) => {
                              if (!acc[item.Sub_Category])
                                acc[item.Sub_Category] = [];
                              acc[item.Sub_Category].push(item);
                              return acc;
                            }, {})
                          ).map(([subCategory, items], groupIndex) => (
                            <React.Fragment key={`debt-group-${groupIndex}`}>
                              {/* Sub-category header */}
                              <tr style={{ backgroundColor: "#d0ebd0" }}>
                                <th
                                  scope="col"
                                  colSpan="14"
                                  style={{ backgroundColor: "#d0ebd0" }}
                                >
                                  <p className="fs-12 text-start m-0 py-2 fw-semibold">
                                    {subCategory}
                                  </p>
                                </th>
                              </tr>
                              {/* Inner schemes table */}
                              <tr className="m-0">
                                <td
                                  colSpan="7"
                                  className="p-0"
                                  style={{ backgroundColor: "#eaf5f1" }}
                                >
                                  <div className="row m-0 p-0">
                                    <table className="table mb-0">
                                      <thead>
                                        <tr>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Scheme name
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Inv Since
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Inv Cost
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Units
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Pur NAV
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Cur NAV
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              NAV date
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              Cur Value
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Gain/Loss
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              XIRR
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Abs return
                                            </span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {/* Schemes under this sub-category */}
                                        {items.map((item, index) => {
                                          const rowKey = `${item.fund_id}_${item.folio_id}`;
                                          const isOpen = expandedRowKey === rowKey;
                                          const currentData = folioData[rowKey];


                                          return (
                                            <React.Fragment key={rowKey}>
                                              {/* Main scheme row */}
                                              <tr>
                                                <td className="text-start">
                                                  <p className="fs-12 m-0">{item.scheme_name}</p>
                                                  <span className="fs-12 fw-bold m-0">{item.folio}</span>
                                                  <span>
                                                    <span
                                                      className="clrgreen ms-2"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => handleOpenTrans(item)}
                                                    >
                                                      {isOpen ? <CiSquareMinus /> : <CiSquarePlus />}
                                                    </span>
                                                  </span>
                                                </td>
                                                <td className="fs-12">{item.InvestedSince}</td>
                                                <td className="fs-12">{formatRupees(item?.inv_cost)}</td>
                                                <td className="fs-12">{Number(item?.UnitsHeld).toFixed(2)}</td>
                                                <td className="fs-12">{Number(item.pur_nav).toFixed(2)}</td>
                                                <td className="fs-12">{Number(item.CurrentNAV).toFixed(2)}</td>
                                                <td className="fs-12">{moment(item.nav_date).format("DD/MM/YYYY")}</td>
                                                <td className="fs-12">{formatRupees(item.cur_value)}</td>
                                                <td className="fs-12">{formatRupees(item?.gain_loss)}</td>
                                                <td className="fs-12">{item.cagr}%</td>
                                                <td className="fs-12">{item.abs_return}%</td>
                                              </tr>

                                              {/* Transactions table */}
                                              {isOpen && (
                                                <tr>
                                                  <td colSpan="14" className="p-1 bg-grey">
                                                    {loading ? (
                                                      <div className="text-center py-3">Loading transactions...</div>
                                                    ) : (
                                                      <table className="table table-sm mb-0">
                                                        <thead className="thead-light">
                                                          <tr>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Txn Type
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Date
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Amount
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Price
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Units
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Cur NAV
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                NAV date
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Value
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Gain/Loss
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Days
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Abs Return
                                                              </span>
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {currentData?.transactions?.length > 0 ? (
                                                            currentData.transactions.map((txn, tIndex) => (
                                                              <tr key={tIndex}>
                                                                <td className="fs-12">
                                                                  {txn.Description
                                                                    ? txn.Description
                                                                      .replace(/In Installment No/gi, "")
                                                                      .replace(/Installment No/gi, "")
                                                                      .replace(/SIP Installment\s*\d+\/\d+/gi, "SIP Purchase")
                                                                      .replace(/^SIP$/, "SIP Purchase")
                                                                      .trim()
                                                                    : ""}
                                                                </td>
                                                                <td className="fs-12">{txn.TransactionDate || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? Number(txn.CreditAmount || 0).toFixed(2)
                                                                    : Number(txn.DebitAmount || 0).toFixed(2)}
                                                                </td>
                                                                <td className="fs-12">{txn.TradePrice || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? Number(txn.CreditUnits || 0).toFixed(2)
                                                                    : Number(txn.DebitUnits || 0).toFixed(2)}
                                                                </td>
                                                                <td className="fs-12">{txn.curr_nav || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.nav_date
                                                                    ? moment(txn.nav_date).format("DD/MM/YYYY")
                                                                    : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward ? formatRupees(txn.curr_val) : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward ? formatRupees(txn?.gain_loss) : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? txn._days
                                                                    : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? `${(parseFloat(txn.abs_return) * 100).toFixed(2)} %`
                                                                    : "--"}

                                                                </td>
                                                              </tr>
                                                            ))
                                                          ) : (
                                                            <tr>
                                                              <td colSpan="11" className="text-center py-2">
                                                                No transactions found
                                                              </td>
                                                            </tr>
                                                          )}

                                                          {/* ✅ Total Row */}
                                                          {currentData?.transactionTotal && (
                                                            <tr>
                                                              <th
                                                                colSpan={2}
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  Total
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {formatRupees(item?.inv_cost) || "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {item
                                                                    .transactionTotal
                                                                    ?.AvgCost ||
                                                                    "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {Number(item?.UnitsHeld).toFixed(2)}
                                                                  {/* {Number(
                                                                    item
                                                                      .transactionTotal
                                                                      ?.UnitsHeld
                                                                  ).toFixed(2) ||
                                                                    "-"} */}
                                                                </span>
                                                              </th>
                                                              <th
                                                                colSpan={3}
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              />
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {formatRupees(item?.gain_loss) || "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">

                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {item?.abs_return ||
                                                                    "-"}
                                                                  %
                                                                </span>
                                                              </th>
                                                            </tr>
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    )}
                                                  </td>
                                                </tr>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                      </>
                    )}

                    {/* ===== DEBT HEADER ===== */}
                    {isDebtportfolioData?.length > 0 && (
                      <>
                        <tr>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            {showDebt ? (
                              <CiSquareMinus
                                className="fs-3 clrgreen"
                                onClick={() => setShowDebt(!showDebt)}
                                style={{ cursor: "pointer" }}
                              />
                            ) : (
                              <CiSquarePlus
                                className="fs-3 clrgreen"
                                onClick={() => setShowDebt(!showDebt)}
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen fw-bold text-start">
                              Debt
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isDebtDiv?.investment)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isDebtDiv?.latest_value)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isDebtDiv?.total_gain_loss)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {/* {(
                                  parsePercentage(isDebtDiv?.cagr) || 0
                                ).toFixed(2)}
                                % */}
                              -
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            {(
                              parsePercentage(isDebtDiv?.absolute_return) || 0
                            ).toFixed(2)}
                            %
                          </td>
                        </tr>

                        {/* ===== SUB-CATEGORY & SCHEMES ===== */}
                        {showDebt &&
                          Object.entries(
                            isDebtportfolioData.reduce((acc, item) => {
                              if (!acc[item.Sub_Category])
                                acc[item.Sub_Category] = [];
                              acc[item.Sub_Category].push(item);
                              return acc;
                            }, {})
                          ).map(([subCategory, items], groupIndex) => (
                            <React.Fragment key={`debt-group-${groupIndex}`}>
                              {/* Sub-category header */}
                              <tr style={{ backgroundColor: "#d0ebd0" }}>
                                <th
                                  scope="col"
                                  colSpan="14"
                                  style={{ backgroundColor: "#d0ebd0" }}
                                >
                                  <p className="fs-12 text-start m-0 py-2 fw-semibold">
                                    {subCategory}
                                  </p>
                                </th>
                              </tr>
                              {/* Inner schemes table */}
                              <tr className="m-0">
                                <td
                                  colSpan="7"
                                  className="p-0"
                                  style={{ backgroundColor: "#eaf5f1" }}
                                >
                                  <div className="row m-0 p-0">
                                    <table className="table mb-0">
                                      <thead>
                                        <tr>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Scheme name
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Inv Since
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Inv Cost
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Units
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Pur NAV
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Cur NAV
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              NAV date
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              Cur Value
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Gain/Loss
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              XIRR
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Abs return
                                            </span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {/* Schemes under this sub-category */}
                                        {items.map((item, index) => {
                                          const rowKey = `${item.fund_id}_${item.folio_id}`;
                                          const isOpen = expandedRowKey === rowKey;
                                          const currentData = folioData[rowKey];


                                          return (
                                            <React.Fragment key={rowKey}>
                                              {/* Main scheme row */}
                                              <tr>
                                                <td className="text-start">
                                                  <p className="fs-12 m-0">{item.scheme_name}</p>
                                                  <span className="fs-12 fw-bold m-0">{item.folio}</span>
                                                  <span>
                                                    <span
                                                      className="clrgreen ms-2"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => handleOpenTrans(item)}
                                                    >
                                                      {isOpen ? <CiSquareMinus /> : <CiSquarePlus />}
                                                    </span>
                                                  </span>
                                                </td>
                                                <td className="fs-12">{item.InvestedSince}</td>
                                                <td className="fs-12">{formatRupees(item?.inv_cost)}</td>
                                                <td className="fs-12">{Number(item?.UnitsHeld).toFixed(2)}</td>
                                                <td className="fs-12">{Number(item.pur_nav).toFixed(2)}</td>
                                                <td className="fs-12">{Number(item.CurrentNAV).toFixed(2)}</td>
                                                <td className="fs-12">{moment(item.nav_date).format("DD/MM/YYYY")}</td>
                                                <td className="fs-12">{formatRupees(item.cur_value)}</td>
                                                <td className="fs-12">{formatRupees(item?.gain_loss)}</td>
                                                <td className="fs-12">{item.cagr}%</td>
                                                <td className="fs-12">{item.abs_return}%</td>
                                              </tr>

                                              {/* Transactions table */}
                                              {isOpen && (
                                                <tr>
                                                  <td colSpan="14" className="p-1 bg-grey">
                                                    {loading ? (
                                                      <div className="text-center py-3">Loading transactions...</div>
                                                    ) : (
                                                      <table className="table table-sm mb-0">
                                                        <thead className="thead-light">
                                                          <tr>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Txn Type
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Date
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Amount
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Price
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Units
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Cur NAV
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                NAV date
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Value
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Gain/Loss
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Days
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Abs Return
                                                              </span>
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {currentData?.transactions?.length > 0 ? (
                                                            currentData.transactions.map((txn, tIndex) => (
                                                              <tr key={tIndex}>
                                                                <td className="fs-12">
                                                                  {txn.Description
                                                                    ? txn.Description
                                                                      .replace(/In Installment No/gi, "")
                                                                      .replace(/Installment No/gi, "")
                                                                      .replace(/SIP Installment\s*\d+\/\d+/gi, "SIP Purchase")
                                                                      .replace(/^SIP$/, "SIP Purchase")
                                                                      .trim()
                                                                    : ""}
                                                                </td>
                                                                <td className="fs-12">{txn.TransactionDate || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? Number(txn.CreditAmount || 0).toFixed(2)
                                                                    : Number(txn.DebitAmount || 0).toFixed(2)}
                                                                </td>
                                                                <td className="fs-12">{txn.TradePrice || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? Number(txn.CreditUnits || 0).toFixed(2)
                                                                    : Number(txn.DebitUnits || 0).toFixed(2)}
                                                                </td>
                                                                <td className="fs-12">{txn.curr_nav || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.nav_date
                                                                    ? moment(txn.nav_date).format("DD/MM/YYYY")
                                                                    : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward ? formatRupees(txn.curr_val) : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward ? formatRupees(txn?.gain_loss) : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? txn._days
                                                                    : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? `${(parseFloat(txn.abs_return) * 100).toFixed(2)} %`
                                                                    : "--"}

                                                                </td>
                                                              </tr>
                                                            ))
                                                          ) : (
                                                            <tr>
                                                              <td colSpan="11" className="text-center py-2">
                                                                No transactions found
                                                              </td>
                                                            </tr>
                                                          )}

                                                          {/* ✅ Total Row */}
                                                          {currentData?.transactionTotal && (
                                                            <tr>
                                                              <th
                                                                colSpan={2}
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  Total
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {formatRupees(item?.inv_cost) || "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {item
                                                                    .transactionTotal
                                                                    ?.AvgCost ||
                                                                    "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {Number(item?.UnitsHeld).toFixed(2)}
                                                                  {/* {Number(
                                                                    item
                                                                      .transactionTotal
                                                                      ?.UnitsHeld
                                                                  ).toFixed(2) ||
                                                                    "-"} */}
                                                                </span>
                                                              </th>
                                                              <th
                                                                colSpan={3}
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              />
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {formatRupees(item?.gain_loss) || "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">

                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {item?.abs_return ||
                                                                    "-"}
                                                                  %
                                                                </span>
                                                              </th>
                                                            </tr>
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    )}
                                                  </td>
                                                </tr>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                      </>
                    )}

                    {/* ===== Others HEADER ===== */}
                    {isOthers?.length > 0 && (
                      <>
                        <tr>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            {showOthers ? (
                              <CiSquareMinus
                                className="fs-3 clrgreen"
                                onClick={() => setShowOthers(!showOthers)}
                                style={{ cursor: "pointer" }}
                              />
                            ) : (
                              <CiSquarePlus
                                className="fs-3 clrgreen"
                                onClick={() => setShowOthers(!showOthers)}
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen fw-bold text-start">
                              Others
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isOtherDiv?.investment)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isOtherDiv?.latest_value)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {formatRupees(isOtherDiv?.total_gain_loss)}
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {/* {(
                                  parsePercentage(isOtherDiv?.cagr) || 0
                                ).toFixed(2)}
                                % */}
                              -
                            </p>
                          </td>
                          <td style={{ backgroundColor: "#F6FBF9" }}>
                            <p className="fs-14 mb-0 clrgreen">
                              {(
                                parsePercentage(isOtherDiv?.absolute_return) || 0
                              ).toFixed(2)}
                              %
                            </p>
                          </td>
                        </tr>

                        {/* ===== SUB-CATEGORY & SCHEMES ===== */}
                        {showOthers &&
                          Object.entries(
                            isOthers.reduce((acc, item) => {
                              if (!acc[item.Sub_Category])
                                acc[item.Sub_Category] = [];
                              acc[item.Sub_Category].push(item);
                              return acc;
                            }, {})
                          ).map(([subCategory, items], groupIndex) => (
                            <React.Fragment key={`debt-group-${groupIndex}`}>
                              {/* Sub-category header */}
                              <tr style={{ backgroundColor: "#d0ebd0" }}>
                                <th
                                  scope="col"
                                  colSpan="14"
                                  style={{ backgroundColor: "#d0ebd0" }}
                                >
                                  <p className="fs-12 text-start m-0 py-2 fw-semibold">
                                    {subCategory}
                                  </p>
                                </th>
                              </tr>
                              {/* Inner schemes table */}
                              <tr className="m-0">
                                <td
                                  colSpan="7"
                                  className="p-0"
                                  style={{ backgroundColor: "#eaf5f1" }}
                                >
                                  <div className="row m-0 p-0">
                                    <table className="table mb-0">
                                      <thead>
                                        <tr>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Scheme name
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Inv Since
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Inv Cost
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Units
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Pur NAV
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Cur NAV
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              NAV date
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              Cur Value
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Gain/Loss
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="none-clrgreen"
                                          >
                                            <span className="fs-12 text-white">
                                              XIRR
                                            </span>
                                          </th>
                                          <th className="none-clrgreen">
                                            <span className="fs-12 text-white">
                                              Abs return
                                            </span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {/* Schemes under this sub-category */}
                                        {items.map((item, index) => {
                                          const rowKey = `${item.fund_id}_${item.folio_id}`;
                                          const isOpen = expandedRowKey === rowKey;
                                          const currentData = folioData[rowKey];


                                          return (
                                            <React.Fragment key={rowKey}>
                                              {/* Main scheme row */}
                                              <tr>
                                                <td className="text-start">
                                                  <p className="fs-12 m-0">{item.scheme_name}</p>
                                                  <span className="fs-12 fw-bold m-0">{item.folio}</span>
                                                  <span>
                                                    <span
                                                      className="clrgreen ms-2"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => handleOpenTrans(item)}
                                                    >
                                                      {isOpen ? <CiSquareMinus /> : <CiSquarePlus />}
                                                    </span>
                                                  </span>
                                                </td>
                                                <td className="fs-12">{item.InvestedSince}</td>
                                                <td className="fs-12">{formatRupees(item?.inv_cost)}</td>
                                                <td className="fs-12">{Number(item?.UnitsHeld).toFixed(2)}</td>
                                                <td className="fs-12">{Number(item.pur_nav).toFixed(2)}</td>
                                                <td className="fs-12">{Number(item.CurrentNAV).toFixed(2)}</td>
                                                <td className="fs-12">{moment(item.nav_date).format("DD/MM/YYYY")}</td>
                                                <td className="fs-12">{formatRupees(item.cur_value)}</td>
                                                <td className="fs-12">{formatRupees(item?.gain_loss)}</td>
                                                <td className="fs-12">{item.cagr}%</td>
                                                <td className="fs-12">{item.abs_return}%</td>
                                              </tr>

                                              {/* Transactions table */}
                                              {isOpen && (
                                                <tr>
                                                  <td colSpan="14" className="p-1 bg-grey">
                                                    {loading ? (
                                                      <div className="text-center py-3">Loading transactions...</div>
                                                    ) : (
                                                      <table className="table table-sm mb-0">
                                                        <thead className="thead-light">
                                                          <tr>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Txn Type
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Date
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Amount
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Price
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Units
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Cur NAV
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                NAV date
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Value
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Gain/Loss
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Days
                                                              </span>
                                                            </th>
                                                            <th className="none-clrgreen">
                                                              <span className="fs-12 text-white">
                                                                Abs Return
                                                              </span>
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {currentData?.transactions?.length > 0 ? (
                                                            currentData.transactions.map((txn, tIndex) => (
                                                              <tr key={tIndex}>
                                                                <td className="fs-12">
                                                                  {txn.Description
                                                                    ? txn.Description
                                                                      .replace(/In Installment No/gi, "")
                                                                      .replace(/Installment No/gi, "")
                                                                      .replace(/SIP Installment\s*\d+\/\d+/gi, "SIP Purchase")
                                                                      .replace(/^SIP$/, "SIP Purchase")
                                                                      .trim()
                                                                    : ""}
                                                                </td>
                                                                <td className="fs-12">{txn.TransactionDate || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? Number(txn.CreditAmount || 0).toFixed(2)
                                                                    : Number(txn.DebitAmount || 0).toFixed(2)}
                                                                </td>
                                                                <td className="fs-12">{txn.TradePrice || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? Number(txn.CreditUnits || 0).toFixed(2)
                                                                    : Number(txn.DebitUnits || 0).toFixed(2)}
                                                                </td>
                                                                <td className="fs-12">{txn.curr_nav || "--"}</td>
                                                                <td className="fs-12">
                                                                  {txn.nav_date
                                                                    ? moment(txn.nav_date).format("DD/MM/YYYY")
                                                                    : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward ? formatRupees(txn.curr_val) : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward ? formatRupees(txn?.gain_loss) : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? txn._days
                                                                    : "--"}
                                                                </td>
                                                                <td className="fs-12">
                                                                  {txn.IsInward
                                                                    ? `${(parseFloat(txn.abs_return) * 100).toFixed(2)} %`
                                                                    : "--"}

                                                                </td>
                                                              </tr>
                                                            ))
                                                          ) : (
                                                            <tr>
                                                              <td colSpan="11" className="text-center py-2">
                                                                No transactions found
                                                              </td>
                                                            </tr>
                                                          )}

                                                          {/* ✅ Total Row */}
                                                          {currentData?.transactionTotal && (
                                                            <tr>
                                                              <th
                                                                colSpan={2}
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  Total
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {formatRupees(item?.inv_cost) || "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {item
                                                                    .transactionTotal
                                                                    ?.AvgCost ||
                                                                    "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {Number(item?.UnitsHeld).toFixed(2)}
                                                                  {/* {Number(
                                                                    item
                                                                      .transactionTotal
                                                                      ?.UnitsHeld
                                                                  ).toFixed(2) ||
                                                                    "-"} */}
                                                                </span>
                                                              </th>
                                                              <th
                                                                colSpan={3}
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              />
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {formatRupees(item?.gain_loss) || "-"}
                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">

                                                                </span>
                                                              </th>
                                                              <th
                                                                style={{
                                                                  backgroundColor:
                                                                    "#F5F9FF",
                                                                }}
                                                              >
                                                                <span className="fs-12">
                                                                  {item?.abs_return ||
                                                                    "-"}
                                                                  %
                                                                </span>
                                                              </th>
                                                            </tr>
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    )}
                                                  </td>
                                                </tr>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                      </>
                    )}
                  </tbody>
                  <tr>
                    <td colSpan={2} className="trbgcolor">
                      Grand Total
                    </td>

                    {/* Investment */}
                    <td className="trbgcolor">
                      <p className="fs-14 mb-0">
                        {/* {formatRupees(
                              (isEquityDiv?.investment || 0) +
                              (isHybridDiv?.investment || 0) +
                              (isDebtDiv?.investment || 0)
                            )} */}
                        {formatRupees(isStatesData?.["Invested Amount"])}
                      </p>
                    </td>

                    {/* Latest Value */}
                    <td className="trbgcolor">
                      <p className="fs-14 mb-0">
                        {/* {formatRupees(
                              (isEquityDiv?.latest_value || 0) +
                              (isHybridDiv?.latest_value || 0) +
                              (isDebtDiv?.latest_value || 0)
                            )} */}
                        {formatRupees(isStatesData?.["Current Value"])}
                      </p>
                    </td>

                    {/* Gain/Loss */}
                    <td className="trbgcolor">
                      <p className="fs-14 mb-0">
                        {/* {formatRupees(
                              (isEquityDiv?.total_gain_loss || 0) +
                              (isHybridDiv?.total_gain_loss || 0) +
                              (isDebtDiv?.total_gain_loss || 0)
                            )} */}
                        {formatRupees(isStatesData?.["Total Gain / Loss"])}
                      </p>
                    </td>

                    {/* CAGR */}
                    <td className="trbgcolor">
                      <p className="fs-14 mb-0">
                        {/* {(
                              (parsePercentage(isEquityDiv?.cagr) || 0) +
                              (parsePercentage(isHybridDiv?.cagr) || 0) +
                              (parsePercentage(isDebtDiv?.cagr) || 0)
                            ).toFixed(2)}% */}
                        {parsePercentage(
                          isStatesData?.["Annualized Return(CAGR)"]
                        )}
                        %
                      </p>
                    </td>

                    {/* Absolute Return */}
                    <td className="trbgcolor">
                      <p className="fs-14 mb-0">
                        {/* {(
                              (parsePercentage(isEquityDiv?.absolute_return) || 0) +
                              (parsePercentage(isHybridDiv?.absolute_return) || 0) +
                              (parsePercentage(isDebtDiv?.absolute_return) || 0)
                            ).toFixed(2)}% */}
                        {parsePercentage(isStatesData?.["Absolute Return"])}%
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            {/* Desktop Table end */}

            {/* Mobile cards */}
            <div className="d-block d-md-none mt-4">

              {isEquityportfolioData?.length > 0 && (
                <>
                  {/* Category Header start */}
                  {/* <h6 className="fw-bold text-success mb-2">{category.category}</h6> */}
                  <div className="row my-2 d-block d-md-none">
                    <div className=" border-color-green px-3 rounded-3 clrgreenlight">
                      {/* <div className="d-flex justify-content-between my-3  ">
                                <strong>{category.category}</strong>
              
                              </div> */}
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Particular</span>
                        <span className="">
                          Equity
                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Inv Cost</span>
                        <span className="">
                          {formatRupees(isEquityDiv?.investment || 0)}

                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Current Val</span>
                        <span className="">
                          {formatRupees(isEquityDiv?.latest_value || 0)}

                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Gain/Loss</span>
                        <span className="">
                          {formatRupees(isEquityDiv?.total_gain_loss || 0)}

                        </span>
                      </div>
                      {/* <div className="d-flex justify-content-between my-3  ">
                                <span>XIRR</span>
                                <span className="">
                                  {calculateTotalFloat(grandTotal?.xirr).toFixed(2)}%
                                </span>
                              </div> */}
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Abs Return</span>
                        <span className="">
                          {(
                            parsePercentage(isEquityDiv?.absolute_return) ||
                            0
                          ).toFixed(2)}
                          %
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* Category Header start end */}
                  {isEquityportfolioData.map((item, idx) => {
                    const isSchemeOpen = expandedSchemes[item.folio_id+item.fund_id];
                    const isTxnOpen = expandedTransactions[idx];
                    const rowKey = `${item.fund_id}_${item.folio_id}`;
                    const isOpen = expandedRowKey === rowKey;
                    const currentData = folioData[rowKey];

                    return (
                      <div key={idx} className="card shadow-sm p-2 mb-3">
                        {/* ===== Scheme Header ===== */}
                        <div
                          className="d-flex justify-content-between align-items-center"
                          onClick={() => toggleScheme(item.folio_id+item.fund_id)}
                          style={{ cursor: "pointer" }}
                        >
                          <p className="fw-bold mb-0">{item.scheme_name}</p>
                          {isSchemeOpen ? (
                            <CiSquareMinus className="fs-4 text-success" />
                          ) : (
                            <CiSquarePlus className="fs-4 text-success" />
                          )}
                        </div>

                        {/* ===== Scheme Details ===== */}
                        {isSchemeOpen && (
                          <div className="mt-2">
                            {[
                              { label: "Folio", value: item.folio },
                              {
                                label: "Invested Since",
                                value: item.InvestedSince,
                              },
                              {
                                label: "Investment",
                                value: formatRupees(item?.inv_cost),
                              },
                              {
                                label: "Units",
                                value: Number(item?.UnitsHeld).toFixed(2),
                              },
                              {
                                label: "Pur NAV",
                                value: Number(item.pur_nav).toFixed(2),
                              },
                              {
                                label: "Cur NAV",
                                value: Number(item.CurrentNAV).toFixed(2),
                              },
                              {
                                label: "NAV date",
                                value: moment(item.nav_date).format("DD/MM/YYYY"),
                              },
                              {
                                label: "Current Value",
                                value: formatRupees(item.cur_value),
                              },
                              {
                                label: "Gain/Loss",
                                value: formatRupees(item?.gain_loss),
                              },
                              { label: "XIRR", value: `${item.cagr}%` },
                              { label: "Abs Return", value: `${item.abs_return}%` },
                            ].map((row, i) => (

                              <div
                                key={i}
                                className="d-flex justify-content-between border-bottom py-1"
                              >
                                <span className="fw-bold">{row.label}</span>
                                <span>{row.value}</span>
                              </div>
                            ))}
                            {/* ===== Transactions Toggle ===== */}
                            <div
                              className="d-flex justify-content-between border-bottom py-1"
                              // onClick={() => toggleTransactions(idx)}
                              onClick={() => handleOpenTrans(item)}
                              style={{ cursor: "pointer" }}
                            >
                              <p className="fw-bold mb-0">Transactions</p>
                              {isOpen ? (
                                <CiSquareMinus className="fs-5 text-success" />
                              ) : (
                                <CiSquarePlus className="fs-5 text-success" />
                              )}
                            </div>
                            {/* )} */}

                            {/* ===== Transactions as Responsive Table ===== */}
                            {isOpen && (
                              <div className="mt-2">
                                <div className="table-responsive">
                                  {loading ? (
                                    <div className="text-center py-3">Loading transactions...</div>
                                  ) : (
                                    <table className="table table-bordered table-striped text-center align-middle">
                                      <thead className="table-light">
                                        <tr>
                                          <th className="text-nowrap txt-color">
                                            Type
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Date
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Amount
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Price
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Units
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Cur NAV
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            NAV date
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Value
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Gain/Loss
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Days
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Abs Return
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {currentData?.transactions?.length > 0 ? (
                                          currentData.transactions.map((txn, tIndex) => (
                                            <tr key={tIndex}>
                                              <td className="fs-12">
                                                {txn.Description
                                                  ? txn.Description
                                                    .replace(/In Installment No/gi, "")
                                                    .replace(/Installment No/gi, "")
                                                    .replace(/SIP Installment\s*\d+\/\d+/gi, "SIP Purchase")
                                                    .replace(/^SIP$/, "SIP Purchase")
                                                    .trim()
                                                  : ""}
                                              </td>
                                              <td className="fs-12">{txn.TransactionDate || "--"}</td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? Number(txn.CreditAmount || 0).toFixed(2)
                                                  : Number(txn.DebitAmount || 0).toFixed(2)}
                                              </td>
                                              <td className="fs-12">{txn.TradePrice || "--"}</td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? Number(txn.CreditUnits || 0).toFixed(2)
                                                  : Number(txn.DebitUnits || 0).toFixed(2)}
                                              </td>
                                              <td className="fs-12">{txn.curr_nav || "--"}</td>
                                              <td className="fs-12">
                                                {txn.nav_date
                                                  ? moment(txn.nav_date).format("DD/MM/YYYY")
                                                  : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward ? formatRupees(txn.curr_val) : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward ? formatRupees(txn?.gain_loss) : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? txn._days
                                                  : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? `${(parseFloat(txn.abs_return) * 100).toFixed(2)} %`
                                                  : "--"}

                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="11" className="text-center py-2">
                                              No transactions found
                                            </td>
                                          </tr>
                                        )}

                                        {/* ✅ Total Row */}
                                        {currentData?.transactionTotal && (
                                          <tr>
                                            <th
                                              colSpan={2}
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                Total
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {formatRupees(item?.inv_cost) || "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {item
                                                  .transactionTotal
                                                  ?.AvgCost ||
                                                  "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {Number(item?.UnitsHeld).toFixed(2)}
                                                {/* {Number(
                                                                    item
                                                                      .transactionTotal
                                                                      ?.UnitsHeld
                                                                  ).toFixed(2) ||
                                                                    "-"} */}
                                              </span>
                                            </th>
                                            <th
                                              colSpan={3}
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            />
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {formatRupees(item?.gain_loss) || "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">

                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {item?.abs_return ||
                                                  "-"}
                                                %
                                              </span>
                                            </th>
                                          </tr>
                                        )}
                                      </tbody>

                                      
                                    </table>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </>
              )}
              {isSIFportfolioData?.length > 0 && (
                <>
                  {/* Category Header start */}
                  {/* <h6 className="fw-bold text-success mb-2">{category.category}</h6> */}
                  <div className="row my-2 d-block d-md-none">
                    <div className=" border-color-green px-3 rounded-3 clrgreenlight">
                      {/* <div className="d-flex justify-content-between my-3  ">
                                <strong>{category.category}</strong>
              
                              </div> */}
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Particular</span>
                        <span className="">
                          SIF
                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Inv Cost</span>
                        <span className="">
                          {formatRupees(isSIFDiv?.investment || 0)}

                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Current Val</span>
                        <span className="">
                          {formatRupees(isSIFDiv?.latest_value || 0)}

                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Gain/Loss</span>
                        <span className="">
                          {formatRupees(isSIFDiv?.total_gain_loss || 0)}

                        </span>
                      </div>
                      {/* <div className="d-flex justify-content-between my-3  ">
                                <span>XIRR</span>
                                <span className="">
                                  {calculateTotalFloat(grandTotal?.xirr).toFixed(2)}%
                                </span>
                              </div> */}
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Abs Return</span>
                        <span className="">
                          {(
                            parsePercentage(isSIFDiv?.absolute_return) ||
                            0
                          ).toFixed(2)}
                          %
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* Category Header start end */}
                  {isSIFportfolioData.map((item, idx) => {
                    const isSchemeOpen = expandedSchemes[item.folio_id+item.fund_id];
                    const isTxnOpen = expandedTransactions[idx];
                    const rowKey = `${item.fund_id}_${item.folio_id}`;
                    const isOpen = expandedRowKey === rowKey;
                    const currentData = folioData[rowKey];

                    return (
                      <div key={idx} className="card shadow-sm p-2 mb-3">
                        {/* ===== Scheme Header ===== */}
                        <div
                          className="d-flex justify-content-between align-items-center"
                          onClick={() => toggleScheme(item.folio_id+item.fund_id)}
                          style={{ cursor: "pointer" }}
                        >
                          <p className="fw-bold mb-0">{item.scheme_name}</p>
                          {isSchemeOpen ? (
                            <CiSquareMinus className="fs-4 text-success" />
                          ) : (
                            <CiSquarePlus className="fs-4 text-success" />
                          )}
                        </div>

                        {/* ===== Scheme Details ===== */}
                        {isSchemeOpen && (
                          <div className="mt-2">
                            {[
                              { label: "Folio", value: item.folio },
                              {
                                label: "Invested Since",
                                value: item.InvestedSince,
                              },
                              {
                                label: "Investment",
                                value: formatRupees(item?.inv_cost),
                              },
                              {
                                label: "Units",
                                value: Number(item?.UnitsHeld).toFixed(2),
                              },
                              {
                                label: "Pur NAV",
                                value: Number(item.pur_nav).toFixed(2),
                              },
                              {
                                label: "Cur NAV",
                                value: Number(item.CurrentNAV).toFixed(2),
                              },
                              {
                                label: "NAV date",
                                value: moment(item.nav_date).format("DD/MM/YYYY"),
                              },
                              {
                                label: "Current Value",
                                value: formatRupees(item.cur_value),
                              },
                              {
                                label: "Gain/Loss",
                                value: formatRupees(item?.gain_loss),
                              },
                              { label: "XIRR", value: `${item.cagr}%` },
                              { label: "Abs Return", value: `${item.abs_return}%` },
                            ].map((row, i) => (

                              <div
                                key={i}
                                className="d-flex justify-content-between border-bottom py-1"
                              >
                                <span className="fw-bold">{row.label}</span>
                                <span>{row.value}</span>
                              </div>
                            ))}
                            {/* ===== Transactions Toggle ===== */}
                            <div
                              className="d-flex justify-content-between border-bottom py-1"
                              // onClick={() => toggleTransactions(idx)}
                              onClick={() => handleOpenTrans(item)}
                              style={{ cursor: "pointer" }}
                            >
                              <p className="fw-bold mb-0">Transactions</p>
                              {isOpen ? (
                                <CiSquareMinus className="fs-5 text-success" />
                              ) : (
                                <CiSquarePlus className="fs-5 text-success" />
                              )}
                            </div>
                            {/* )} */}

                            {/* ===== Transactions as Responsive Table ===== */}
                            {isOpen && (
                              <div className="mt-2">
                                <div className="table-responsive">
                                  {loading ? (
                                    <div className="text-center py-3">Loading transactions...</div>
                                  ) : (
                                    <table className="table table-bordered table-striped text-center align-middle">
                                      <thead className="table-light">
                                        <tr>
                                          <th className="text-nowrap txt-color">
                                            Type
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Date
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Amount
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Price
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Units
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Cur NAV
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            NAV date
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Value
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Gain/Loss
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Days
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Abs Return
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {currentData?.transactions?.length > 0 ? (
                                          currentData.transactions.map((txn, tIndex) => (
                                            <tr key={tIndex}>
                                              <td className="fs-12">
                                                {txn.Description
                                                  ? txn.Description
                                                    .replace(/In Installment No/gi, "")
                                                    .replace(/Installment No/gi, "")
                                                    .replace(/SIP Installment\s*\d+\/\d+/gi, "SIP Purchase")
                                                    .replace(/^SIP$/, "SIP Purchase")
                                                    .trim()
                                                  : ""}
                                              </td>
                                              <td className="fs-12">{txn.TransactionDate || "--"}</td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? Number(txn.CreditAmount || 0).toFixed(2)
                                                  : Number(txn.DebitAmount || 0).toFixed(2)}
                                              </td>
                                              <td className="fs-12">{txn.TradePrice || "--"}</td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? Number(txn.CreditUnits || 0).toFixed(2)
                                                  : Number(txn.DebitUnits || 0).toFixed(2)}
                                              </td>
                                              <td className="fs-12">{txn.curr_nav || "--"}</td>
                                              <td className="fs-12">
                                                {txn.nav_date
                                                  ? moment(txn.nav_date).format("DD/MM/YYYY")
                                                  : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward ? formatRupees(txn.curr_val) : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward ? formatRupees(txn?.gain_loss) : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? txn._days
                                                  : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? `${(parseFloat(txn.abs_return) * 100).toFixed(2)} %`
                                                  : "--"}

                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="11" className="text-center py-2">
                                              No transactions found
                                            </td>
                                          </tr>
                                        )}

                                        {/* ✅ Total Row */}
                                        {currentData?.transactionTotal && (
                                          <tr>
                                            <th
                                              colSpan={2}
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                Total
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {formatRupees(item?.inv_cost) || "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {item
                                                  .transactionTotal
                                                  ?.AvgCost ||
                                                  "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {Number(item?.UnitsHeld).toFixed(2)}
                                                {/* {Number(
                                                                    item
                                                                      .transactionTotal
                                                                      ?.UnitsHeld
                                                                  ).toFixed(2) ||
                                                                    "-"} */}
                                              </span>
                                            </th>
                                            <th
                                              colSpan={3}
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            />
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {formatRupees(item?.gain_loss) || "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">

                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {item?.abs_return ||
                                                  "-"}
                                                %
                                              </span>
                                            </th>
                                          </tr>
                                        )}
                                      </tbody>

                                      
                                    </table>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </>
              )}
              {isHybridportfolioData?.length > 0 && (
                <>
                  {/* Category Header start */}
                  {/* <h6 className="fw-bold text-success mb-2">{category.category}</h6> */}
                  <div className="row my-2 d-block d-md-none">
                    <div className=" border-color-green px-3 rounded-3 clrgreenlight">
                      {/* <div className="d-flex justify-content-between my-3  ">
                                <strong>{category.category}</strong>
              
                              </div> */}
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Particular</span>
                        <span className="">
                          Hybrid

                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Inv Cost</span>
                        <span className="">
                          {formatRupees(isHybridDiv?.investment || 0)}


                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Current Val</span>
                        <span className="">
                          {formatRupees(isHybridDiv?.latest_value)}


                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Gain/Loss</span>
                        <span className="">
                          {formatRupees(isHybridDiv?.total_gain_loss)}


                        </span>
                      </div>
                      {/* <div className="d-flex justify-content-between my-3  ">
                                <span>XIRR</span>
                                <span className="">
                                  {calculateTotalFloat(grandTotal?.xirr).toFixed(2)}%
                                </span>
                              </div> */}
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Abs Return</span>
                        <span className="">
                          {(
                            parsePercentage(isHybridDiv?.absolute_return) ||
                            0
                          ).toFixed(2)}
                          %
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* Category Header start end */}
                  {isHybridportfolioData.map((item, idx) => {
                    const isSchemeOpen = expandedSchemes[item.folio_id+item.fund_id];
                    const isTxnOpen = expandedTransactions[idx];
                     const rowKey = `${item.fund_id}_${item.folio_id}`;
                    const isOpen = expandedRowKey === rowKey;
                    const currentData = folioData[rowKey];

                    return (
                      <div key={idx} className="card shadow-sm p-2 mb-3">
                        {/* ===== Scheme Header ===== */}
                        <div
                          className="d-flex justify-content-between align-items-center"
                          onClick={() => toggleScheme(item.folio_id+item.fund_id)}
                          style={{ cursor: "pointer" }}
                        >
                          <p className="fw-bold mb-0">{item.scheme_name}</p>
                          {isSchemeOpen ? (
                            <CiSquareMinus className="fs-4 text-success" />
                          ) : (
                            <CiSquarePlus className="fs-4 text-success" />
                          )}
                        </div>

                        {/* ===== Scheme Details ===== */}
                        {isSchemeOpen && (
                          <div className="mt-2">
                            {[
                              { label: "Folio", value: item.folio },
                              {
                                label: "Invested Since",
                                value: item.InvestedSince,
                              },
                              {
                                label: "Investment",
                                value: formatRupees(item?.inv_cost),
                              },
                              {
                                label: "Units",
                                value: Number(item?.UnitsHeld).toFixed(2),
                              },
                              {
                                label: "Pur NAV",
                                value: Number(item.pur_nav).toFixed(2),
                              },
                              {
                                label: "Cur NAV",
                                value: Number(item.CurrentNAV).toFixed(2),
                              },
                              {
                                label: "NAV date",
                                value: moment(item.nav_date).format("DD/MM/YYYY"),
                              },
                              {
                                label: "Current Value",
                                value: formatRupees(item.cur_value),
                              },
                              {
                                label: "Gain/Loss",
                                value: formatRupees(item?.gain_loss),
                              },
                              { label: "XIRR", value: `${item.cagr}%` },
                              { label: "Abs Return", value: `${item.abs_return}%` },
                            ].map((row, i) => (
                              <div
                                key={i}
                                className="d-flex justify-content-between border-bottom py-1"
                              >
                                <span className="fw-bold">{row.label}</span>
                                <span>{row.value}</span>
                              </div>
                            ))}

                            {/* ===== Transactions Toggle ===== */}
                            <div
                              className="d-flex justify-content-between border-bottom py-1"
                              // onClick={() => toggleTransactions(idx)}
                              onClick={() => handleOpenTrans(item)}
                              style={{ cursor: "pointer" }}
                            >
                              <p className="fw-bold mb-0">Transactions</p>
                              {isOpen ? (
                                <CiSquareMinus className="fs-5 text-success" />
                              ) : (
                                <CiSquarePlus className="fs-5 text-success" />
                              )}
                            </div>
                            {/* )} */}

                            {/* ===== Transactions as Responsive Table ===== */}
                            {isOpen && (
                              <div className="mt-2">
                                <div className="table-responsive">
                                  {loading ? (
                                    <div className="text-center py-3">Loading transactions...</div>
                                  ) : (
                                    <table className="table table-bordered table-striped text-center align-middle">
                                      <thead className="table-light">
                                        <tr>
                                          <th className="text-nowrap txt-color">
                                            Type
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Date
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Amount
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Price
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Units
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Cur NAV
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            NAV date
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Value
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Gain/Loss
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Days
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Abs Return
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {currentData?.transactions?.length > 0 ? (
                                          currentData.transactions.map((txn, tIndex) => (
                                            <tr key={tIndex}>
                                              <td className="fs-12">
                                                {txn.Description
                                                  ? txn.Description
                                                    .replace(/In Installment No/gi, "")
                                                    .replace(/Installment No/gi, "")
                                                    .replace(/SIP Installment\s*\d+\/\d+/gi, "SIP Purchase")
                                                    .replace(/^SIP$/, "SIP Purchase")
                                                    .trim()
                                                  : ""}
                                              </td>
                                              <td className="fs-12">{txn.TransactionDate || "--"}</td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? Number(txn.CreditAmount || 0).toFixed(2)
                                                  : Number(txn.DebitAmount || 0).toFixed(2)}
                                              </td>
                                              <td className="fs-12">{txn.TradePrice || "--"}</td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? Number(txn.CreditUnits || 0).toFixed(2)
                                                  : Number(txn.DebitUnits || 0).toFixed(2)}
                                              </td>
                                              <td className="fs-12">{txn.curr_nav || "--"}</td>
                                              <td className="fs-12">
                                                {txn.nav_date
                                                  ? moment(txn.nav_date).format("DD/MM/YYYY")
                                                  : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward ? formatRupees(txn.curr_val) : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward ? formatRupees(txn?.gain_loss) : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? txn._days
                                                  : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? `${(parseFloat(txn.abs_return) * 100).toFixed(2)} %`
                                                  : "--"}

                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="11" className="text-center py-2">
                                              No transactions found
                                            </td>
                                          </tr>
                                        )}

                                        {/* ✅ Total Row */}
                                        {currentData?.transactionTotal && (
                                          <tr>
                                            <th
                                              colSpan={2}
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                Total
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {formatRupees(item?.inv_cost) || "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {item
                                                  .transactionTotal
                                                  ?.AvgCost ||
                                                  "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {Number(item?.UnitsHeld).toFixed(2)}
                                                {/* {Number(
                                                                    item
                                                                      .transactionTotal
                                                                      ?.UnitsHeld
                                                                  ).toFixed(2) ||
                                                                    "-"} */}
                                              </span>
                                            </th>
                                            <th
                                              colSpan={3}
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            />
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {formatRupees(item?.gain_loss) || "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">

                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {item?.abs_return ||
                                                  "-"}
                                                %
                                              </span>
                                            </th>
                                          </tr>
                                        )}
                                      </tbody>

                                      
                                    </table>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </>
              )}
              {isDebtportfolioData?.length > 0 && (
                <>
                  {/* Category Header start */}
                  {/* <h6 className="fw-bold text-success mb-2">{category.category}</h6> */}
                  <div className="row my-2 d-block d-md-none">
                    <div className=" border-color-green px-3 rounded-3 clrgreenlight">
                      {/* <div className="d-flex justify-content-between my-3  ">
                                <strong>{category.category}</strong>
              
                              </div> */}
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Particular</span>
                        <span className="">
                          Debt
                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Inv Cost</span>
                        <span className="">
                          {formatRupees(isDebtDiv?.investment)}

                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Current Val</span>
                        <span className="">
                          {formatRupees(isDebtDiv?.latest_value)}

                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Gain/Loss</span>
                        <span className="">
                          {formatRupees(isDebtDiv?.total_gain_loss)}

                        </span>
                      </div>
                      {/* <div className="d-flex justify-content-between my-3  ">
                                <span>XIRR</span>
                                <span className="">
                                  {calculateTotalFloat(grandTotal?.xirr).toFixed(2)}%
                                </span>
                              </div> */}
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Abs Return</span>
                        <span className="">
                          {(
                            parsePercentage(isDebtDiv?.absolute_return) || 0
                          ).toFixed(2)}
                          %
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* Category Header start end */}
                  {isDebtportfolioData.map((item, idx) => {
                    const isSchemeOpen = expandedSchemes[item.folio_id+item.fund_id];
                    const isTxnOpen = expandedTransactions[idx];
                    const rowKey = `${item.fund_id}_${item.folio_id}`;
                    const isOpen = expandedRowKey === rowKey;
                    const currentData = folioData[rowKey];

                    return (
                      <div key={idx} className="card shadow-sm p-2 mb-3">
                        {/* ===== Scheme Header ===== */}
                        <div
                          className="d-flex justify-content-between align-items-center"
                          onClick={() => toggleScheme(item.folio_id+item.fund_id)}
                          style={{ cursor: "pointer" }}
                        >
                          <p className="fw-bold mb-0">{item.scheme_name}</p>
                          {isSchemeOpen ? (
                            <CiSquareMinus className="fs-4 text-success" />
                          ) : (
                            <CiSquarePlus className="fs-4 text-success" />
                          )}
                        </div>

                        {/* ===== Scheme Details ===== */}
                        {isSchemeOpen && (
                          <div className="mt-2">
                            {[
                              { label: "Folio", value: item.folio },
                              {
                                label: "Invested Since",
                                value: item.InvestedSince,
                              },
                              {
                                label: "Investment",
                                value: formatRupees(item?.inv_cost),
                              },
                              {
                                label: "Units",
                                value: Number(item?.UnitsHeld).toFixed(2),
                              },
                              {
                                label: "Pur NAV",
                                value: Number(item.pur_nav).toFixed(2),
                              },
                              {
                                label: "Cur NAV",
                                value: Number(item.CurrentNAV).toFixed(2),
                              },
                              {
                                label: "NAV date",
                                value: moment(item.nav_date).format("DD/MM/YYYY"),
                              },
                              {
                                label: "Current Value",
                                value: formatRupees(item.cur_value),
                              },
                              {
                                label: "Gain/Loss",
                                value: formatRupees(item?.gain_loss),
                              },
                              { label: "XIRR", value: `${item.cagr}%` },
                              { label: "Abs Return", value: `${item.abs_return}%` },
                            ].map((row, i) => (
                              <div
                                key={i}
                                className="d-flex justify-content-between border-bottom py-1"
                              >
                                <span className="fw-bold">{row.label}</span>
                                <span>{row.value}</span>
                              </div>
                            ))}

                            {/* ===== Transactions Toggle ===== */}
                            <div
                              className="d-flex justify-content-between border-bottom py-1"
                              // onClick={() => toggleTransactions(idx)}
                              onClick={() => handleOpenTrans(item)}
                              style={{ cursor: "pointer" }}
                            >
                              <p className="fw-bold mb-0">Transactions</p>
                              {isOpen ? (
                                <CiSquareMinus className="fs-5 text-success" />
                              ) : (
                                <CiSquarePlus className="fs-5 text-success" />
                              )}
                            </div>
                            {/* )} */}

                            {/* ===== Transactions as Responsive Table ===== */}
                            {isOpen && (
                              <div className="mt-2">
                                <div className="table-responsive">
                                  {loading ? (
                                    <div className="text-center py-3">Loading transactions...</div>
                                  ) : (
                                    <table className="table table-bordered table-striped text-center align-middle">
                                      <thead className="table-light">
                                        <tr>
                                          <th className="text-nowrap txt-color">
                                            Type
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Date
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Amount
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Price
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Units
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Cur NAV
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            NAV date
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Value
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Gain/Loss
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Days
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Abs Return
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {currentData?.transactions?.length > 0 ? (
                                          currentData.transactions.map((txn, tIndex) => (
                                            <tr key={tIndex}>
                                              <td className="fs-12">
                                                {txn.Description
                                                  ? txn.Description
                                                    .replace(/In Installment No/gi, "")
                                                    .replace(/Installment No/gi, "")
                                                    .replace(/SIP Installment\s*\d+\/\d+/gi, "SIP Purchase")
                                                    .replace(/^SIP$/, "SIP Purchase")
                                                    .trim()
                                                  : ""}
                                              </td>
                                              <td className="fs-12">{txn.TransactionDate || "--"}</td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? Number(txn.CreditAmount || 0).toFixed(2)
                                                  : Number(txn.DebitAmount || 0).toFixed(2)}
                                              </td>
                                              <td className="fs-12">{txn.TradePrice || "--"}</td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? Number(txn.CreditUnits || 0).toFixed(2)
                                                  : Number(txn.DebitUnits || 0).toFixed(2)}
                                              </td>
                                              <td className="fs-12">{txn.curr_nav || "--"}</td>
                                              <td className="fs-12">
                                                {txn.nav_date
                                                  ? moment(txn.nav_date).format("DD/MM/YYYY")
                                                  : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward ? formatRupees(txn.curr_val) : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward ? formatRupees(txn?.gain_loss) : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? txn._days
                                                  : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? `${(parseFloat(txn.abs_return) * 100).toFixed(2)} %`
                                                  : "--"}

                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="11" className="text-center py-2">
                                              No transactions found
                                            </td>
                                          </tr>
                                        )}

                                        {/* ✅ Total Row */}
                                        {currentData?.transactionTotal && (
                                          <tr>
                                            <th
                                              colSpan={2}
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                Total
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {formatRupees(item?.inv_cost) || "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {item
                                                  .transactionTotal
                                                  ?.AvgCost ||
                                                  "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {Number(item?.UnitsHeld).toFixed(2)}
                                                {/* {Number(
                                                                    item
                                                                      .transactionTotal
                                                                      ?.UnitsHeld
                                                                  ).toFixed(2) ||
                                                                    "-"} */}
                                              </span>
                                            </th>
                                            <th
                                              colSpan={3}
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            />
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {formatRupees(item?.gain_loss) || "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">

                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {item?.abs_return ||
                                                  "-"}
                                                %
                                              </span>
                                            </th>
                                          </tr>
                                        )}
                                      </tbody>

                                      
                                    </table>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </>
              )}
              {isOthers?.length > 0 && (
                <>
                  {/* Category Header start */}
                  {/* <h6 className="fw-bold text-success mb-2">{category.category}</h6> */}
                  <div className="row my-2 d-block d-md-none">
                    <div className=" border-color-green px-3 rounded-3 clrgreenlight">
                      {/* <div className="d-flex justify-content-between my-3  ">
                                <strong>{category.category}</strong>
              
                              </div> */}
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Particular</span>
                        <span className="">
                          Others
                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Inv Cost</span>
                        <span className="">
                          {formatRupees(isOtherDiv?.investment)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Current Val</span>
                        <span className="">
                          {formatRupees(isOtherDiv?.latest_value)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Gain/Loss</span>
                        <span className="">
                          {formatRupees(isOtherDiv?.total_gain_loss)}
                        </span>
                      </div>
                      {/* <div className="d-flex justify-content-between my-3  ">
                                <span>XIRR</span>
                                <span className="">
                                  {calculateTotalFloat(grandTotal?.xirr).toFixed(2)}%
                                </span>
                              </div> */}
                      <div className="d-flex justify-content-between my-3  ">
                        <span>Abs Return</span>
                        <span className="">
                          {(
                            parsePercentage(isOtherDiv?.absolute_return) || 0
                          ).toFixed(2)}
                          %
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* Category Header start end */}
                  {isOthers.map((item, idx) => {
                    const isSchemeOpen = expandedSchemes[item.folio_id+item.fund_id];
                    const isTxnOpen = expandedTransactions[idx];
                     const rowKey = `${item.fund_id}_${item.folio_id}`;
                    const isOpen = expandedRowKey === rowKey;
                    const currentData = folioData[rowKey];

                    return (
                      <div key={idx} className="card shadow-sm p-2 mb-3">
                        {/* ===== Scheme Header ===== */}
                        <div
                          className="d-flex justify-content-between align-items-center"
                          onClick={() => toggleScheme(item.folio_id+item.fund_id)}
                          style={{ cursor: "pointer" }}
                        >
                          <p className="fw-bold mb-0">{item.scheme_name}</p>
                          {isSchemeOpen ? (
                            <CiSquareMinus className="fs-4 text-success" />
                          ) : (
                            <CiSquarePlus className="fs-4 text-success" />
                          )}
                        </div>

                        {/* ===== Scheme Details ===== */}
                        {isSchemeOpen && (
                          <div className="mt-2">
                            {[
                              { label: "Folio", value: item.folio },
                              {
                                label: "Invested Since",
                                value: item.InvestedSince,
                              },
                              {
                                label: "Investment",
                                value: formatRupees(item?.inv_cost),
                              },
                              {
                                label: "Units",
                                value: Number(item?.UnitsHeld).toFixed(2),
                              },
                              {
                                label: "Pur NAV",
                                value: Number(item.pur_nav).toFixed(2),
                              },
                              {
                                label: "Cur NAV",
                                value: Number(item.CurrentNAV).toFixed(2),
                              },
                              {
                                label: "NAV date",
                                value: moment(item.nav_date).format("DD/MM/YYYY"),
                              },
                              {
                                label: "Current Value",
                                value: formatRupees(item.cur_value),
                              },
                              {
                                label: "Gain/Loss",
                                value: formatRupees(item?.gain_loss),
                              },
                              { label: "XIRR", value: `${item.cagr}%` },
                              { label: "Abs Return", value: `${item.abs_return}%` },
                            ].map((row, i) => (
                              <div
                                key={i}
                                className="d-flex justify-content-between border-bottom py-1"
                              >
                                <span className="fw-bold">{row.label}</span>
                                <span>{row.value}</span>
                              </div>
                            ))}

                            {/* ===== Transactions Toggle ===== */}
                            <div
                              className="d-flex justify-content-between border-bottom py-1"
                              // onClick={() => toggleTransactions(idx)}
                              onClick={() => handleOpenTrans(item)}
                              style={{ cursor: "pointer" }}
                            >
                              <p className="fw-bold mb-0">Transactions</p>
                              {isOpen ? (
                                <CiSquareMinus className="fs-5 text-success" />
                              ) : (
                                <CiSquarePlus className="fs-5 text-success" />
                              )}
                            </div>
                            {/* )} */}

                            {/* ===== Transactions as Responsive Table ===== */}
                            {isOpen && (
                              <div className="mt-2">
                                <div className="table-responsive">
                                  {loading ? (
                                    <div className="text-center py-3">Loading transactions...</div>
                                  ) : (
                                    <table className="table table-bordered table-striped text-center align-middle">
                                      <thead className="table-light">
                                        <tr>
                                          <th className="text-nowrap txt-color">
                                            Type
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Date
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Amount
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Price
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Units
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Cur NAV
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            NAV date
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Value
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Gain/Loss
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Days
                                          </th>
                                          <th className="text-nowrap txt-color">
                                            Abs Return
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {currentData?.transactions?.length > 0 ? (
                                          currentData.transactions.map((txn, tIndex) => (
                                            <tr key={tIndex}>
                                              <td className="fs-12">
                                                {txn.Description
                                                  ? txn.Description
                                                    .replace(/In Installment No/gi, "")
                                                    .replace(/Installment No/gi, "")
                                                    .replace(/SIP Installment\s*\d+\/\d+/gi, "SIP Purchase")
                                                    .replace(/^SIP$/, "SIP Purchase")
                                                    .trim()
                                                  : ""}
                                              </td>
                                              <td className="fs-12">{txn.TransactionDate || "--"}</td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? Number(txn.CreditAmount || 0).toFixed(2)
                                                  : Number(txn.DebitAmount || 0).toFixed(2)}
                                              </td>
                                              <td className="fs-12">{txn.TradePrice || "--"}</td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? Number(txn.CreditUnits || 0).toFixed(2)
                                                  : Number(txn.DebitUnits || 0).toFixed(2)}
                                              </td>
                                              <td className="fs-12">{txn.curr_nav || "--"}</td>
                                              <td className="fs-12">
                                                {txn.nav_date
                                                  ? moment(txn.nav_date).format("DD/MM/YYYY")
                                                  : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward ? formatRupees(txn.curr_val) : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward ? formatRupees(txn?.gain_loss) : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? txn._days
                                                  : "--"}
                                              </td>
                                              <td className="fs-12">
                                                {txn.IsInward
                                                  ? `${(parseFloat(txn.abs_return) * 100).toFixed(2)} %`
                                                  : "--"}

                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="11" className="text-center py-2">
                                              No transactions found
                                            </td>
                                          </tr>
                                        )}

                                        {/* ✅ Total Row */}
                                        {currentData?.transactionTotal && (
                                          <tr>
                                            <th
                                              colSpan={2}
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                Total
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {formatRupees(item?.inv_cost) || "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {item
                                                  .transactionTotal
                                                  ?.AvgCost ||
                                                  "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {Number(item?.UnitsHeld).toFixed(2)}
                                                {/* {Number(
                                                                    item
                                                                      .transactionTotal
                                                                      ?.UnitsHeld
                                                                  ).toFixed(2) ||
                                                                    "-"} */}
                                              </span>
                                            </th>
                                            <th
                                              colSpan={3}
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            />
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {formatRupees(item?.gain_loss) || "-"}
                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">

                                              </span>
                                            </th>
                                            <th
                                              style={{
                                                backgroundColor:
                                                  "#F5F9FF",
                                              }}
                                            >
                                              <span className="fs-12">
                                                {item?.abs_return ||
                                                  "-"}
                                                %
                                              </span>
                                            </th>
                                          </tr>
                                        )}
                                      </tbody>

                                      
                                    </table>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </>
              )}
            </div>
            <div className="row my-5 d-block d-md-none">
              <div className=" border-color-green px-3 rounded-3 clrgreenlight">
                <div className="d-flex justify-content-between my-3  ">
                  <strong>Grand Total</strong>
                </div>
                <div className="d-flex justify-content-between my-3  ">
                  <span>Inv Cost</span>
                  <span className="">
                    {formatRupees(isStatesData?.["Invested Amount"])}
                  </span>
                </div>
                <div className="d-flex justify-content-between my-3  ">
                  <span>Current Val</span>
                  <span className="">
                    {formatRupees(isStatesData?.["Current Value"])}
                  </span>
                </div>
                <div className="d-flex justify-content-between my-3  ">
                  <span>Gain/Loss</span>
                  <span className="">
                    {formatRupees(isStatesData?.["Total Gain / Loss"])}
                  </span>
                </div>
                <div className="d-flex justify-content-between my-3  ">
                  <span>XIRR</span>
                  <span className="">
                    {calculateTotalFloat(
                      isStatesData?.["Annualized Return(CAGR)"]
                    )}
                    %{/* {calculateTotalFloat(grandTotal?.xirr).toFixed(2)}% */}
                  </span>
                </div>
                <div className="d-flex justify-content-between my-3  ">
                  <span>Abs Return</span>
                  <span className="">
                    {/* {calculateTotalFloat(grandTotal??.absReturn).toFixed(2)}% */}
                    {calculateTotalFloat(isStatesData?.["Absolute Return"])}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <table className="border p-2 " style={{ borderColor: "#52B58C" }}>
            {/* <tbody>
              <tr>
                <td colspan={2} className="trbgcolor">
                  Grand Total
                </td>

                <td className="trbgcolor">
                  <p className="fs-14 mb-0 ">0</p>
                </td>
                <td className="trbgcolor">
                  <p className="fs-14 mb-0 ">0</p>
                </td>
                <td className="trbgcolor">
                  <p className="fs-14 mb-0 ">0</p>
                </td>
                <td className="trbgcolor">
                  <p className="fs-14 mb-0 ">0</p>
                </td>
                <td className="trbgcolor">
                  <p className="fs-14 mb-0 ">0</p>
                </td>
              </tr>
            </tbody> */}
          </table>
        )}
      </div>
    </div>
  );
};

export default PortfolioDetails;
